import { render } from "./KeyboardNavHint.vue?vue&type=template&id=bc55920e&scoped=true&ts=true"
import script from "./KeyboardNavHint.vue?vue&type=script&lang=ts"
export * from "./KeyboardNavHint.vue?vue&type=script&lang=ts"

import "./KeyboardNavHint.vue?vue&type=style&index=0&id=bc55920e&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc55920e"]])

export default __exports__